(() => {
(function() {
    const blockSelector = '[data-bmtg-tour-360]';
    const enabledClassName = 'is-enabled';
    const fullscreenClassName = 'is-fullscreen';
    const cookieBlockerClassName = 'has-cookie-blocker';
    let activeBlock = null;
    let pendingViewportCheck = false;
    const getIframe = (block)=>block.querySelector('iframe');
    const getOverlay = (block)=>block.querySelector('[data-bmtg-tour-360-overlay]');
    const getToggles = (block)=>Array.prototype.slice.call(block.querySelectorAll('[data-bmtg-tour-360-toggle]'));
    const getCloseButton = (block)=>block.querySelector('[data-bmtg-tour-360-close]');
    const getViewportHeight = ()=>window.innerHeight || document.documentElement.clientHeight;
    const hasCookieBlocker = (block)=>Array.prototype.some.call(block.children, (child)=>child.classList.contains('brlbs-cmpnt-content-blocker'));
    const getFullscreenElement = ()=>document.fullscreenElement || document.webkitFullscreenElement || document.mozFullScreenElement || document.msFullscreenElement || null;
    const getFullscreenBlock = ()=>{
        const fullscreenElement = getFullscreenElement();
        if (!fullscreenElement || !fullscreenElement.closest) return null;
        return fullscreenElement.closest(blockSelector);
    };
    const isBlockFullscreen = (block)=>getFullscreenBlock() === block;
    const syncCookieBlockerState = (block)=>{
        const isBlocked = hasCookieBlocker(block);
        block.classList.toggle(cookieBlockerClassName, isBlocked);
        if (!isBlocked) return;
        setBlockEnabled(block, false);
        if (activeBlock === block) activeBlock = null;
    };
    const captureScrollPosition = (block)=>{
        const rect = block.getBoundingClientRect();
        return {
            x: window.pageXOffset,
            y: window.pageYOffset,
            wasVisible: rect.bottom > 0 && rect.top < getViewportHeight()
        };
    };
    const restoreScrollPosition = (block, scrollPosition)=>{
        if (!scrollPosition || !scrollPosition.wasVisible || isBlockFullscreen(block)) return;
        const jumpedUp = window.pageYOffset < scrollPosition.y - 64;
        const jumpedSideways = Math.abs(window.pageXOffset - scrollPosition.x) > 24;
        if (!jumpedUp && !jumpedSideways) return;
        try {
            window.scrollTo({
                left: scrollPosition.x,
                top: scrollPosition.y,
                behavior: 'instant'
            });
        } catch (error) {
            window.scrollTo(scrollPosition.x, scrollPosition.y);
        }
    };
    const preserveScrollAroundIframeLoad = (block, iframe, scrollPosition, watchLoad)=>{
        const restore = ()=>restoreScrollPosition(block, scrollPosition);
        let guardTimeout = null;
        const stopScrollGuard = ()=>{
            window.removeEventListener('scroll', restore, true);
            if (guardTimeout) {
                window.clearTimeout(guardTimeout);
                guardTimeout = null;
            }
        };
        window.addEventListener('scroll', restore, {
            capture: true,
            passive: true
        });
        guardTimeout = window.setTimeout(stopScrollGuard, 6000);
        window.requestAnimationFrame(restore);
        window.setTimeout(restore, 80);
        if (!watchLoad || !iframe) return;
        const handleLoad = ()=>{
            restore();
            window.setTimeout(restore, 80);
        };
        iframe.addEventListener('load', handleLoad, {
            once: true
        });
        window.setTimeout(()=>{
            iframe.removeEventListener('load', handleLoad);
            stopScrollGuard();
        }, 6000);
    };
    const setActiveToggle = (block, activeToggle)=>{
        getToggles(block).forEach((toggle)=>{
            toggle.classList.toggle('is-active-tour', toggle === activeToggle);
        });
    };
    const syncIframeFromToggle = (block, toggle)=>{
        const iframe = getIframe(block);
        if (!iframe || !toggle) return {
            iframe: iframe,
            srcChanged: false
        };
        const nextSrc = toggle.getAttribute('data-bmtg-tour-360-src');
        const nextTitle = toggle.getAttribute('data-bmtg-tour-360-title');
        let srcChanged = false;
        if (nextSrc && iframe.getAttribute('src') !== nextSrc) {
            iframe.setAttribute('src', nextSrc);
            srcChanged = true;
        }
        if (nextTitle) iframe.setAttribute('title', nextTitle);
        setActiveToggle(block, toggle);
        return {
            iframe: iframe,
            srcChanged: srcChanged
        };
    };
    const setBlockEnabled = (block, enabled)=>{
        const iframe = getIframe(block);
        const overlay = getOverlay(block);
        const toggles = getToggles(block);
        const closeButton = getCloseButton(block);
        block.classList.toggle(enabledClassName, enabled);
        if (iframe) iframe.setAttribute('tabindex', enabled ? '0' : '-1');
        if (overlay) overlay.setAttribute('aria-hidden', enabled ? 'true' : 'false');
        toggles.forEach((toggle)=>{
            toggle.tabIndex = enabled ? -1 : 0;
        });
        if (closeButton) {
            closeButton.tabIndex = enabled ? 0 : -1;
            closeButton.setAttribute('aria-hidden', enabled ? 'false' : 'true');
        }
    };
    const focusActiveToggle = (block)=>{
        const activeToggle = block.querySelector('[data-bmtg-tour-360-toggle].is-active-tour') || getToggles(block)[0];
        if (!activeToggle) return;
        try {
            activeToggle.focus({
                preventScroll: true
            });
        } catch (error) {
            activeToggle.focus();
        }
    };
    const disableBlock = (block, shouldRestoreFocus)=>{
        if (!block || isBlockFullscreen(block)) return;
        setBlockEnabled(block, false);
        if (activeBlock === block) activeBlock = null;
        if (shouldRestoreFocus) focusActiveToggle(block);
    };
    const disableActiveBlock = ()=>{
        if (!activeBlock) return;
        disableBlock(activeBlock, false);
    };
    const isActiveBlockMostlyVisible = ()=>{
        if (!activeBlock) return false;
        const rect = activeBlock.getBoundingClientRect();
        const viewportHeight = getViewportHeight();
        const visibleHeight = Math.min(rect.bottom, viewportHeight) - Math.max(rect.top, 0);
        const ratio = visibleHeight / Math.min(rect.height || 1, viewportHeight || 1);
        return visibleHeight > 0 && ratio >= 0.35;
    };
    const scheduleViewportCheck = ()=>{
        if (!activeBlock || pendingViewportCheck || isBlockFullscreen(activeBlock)) return;
        pendingViewportCheck = true;
        window.requestAnimationFrame(()=>{
            pendingViewportCheck = false;
            if (!isActiveBlockMostlyVisible()) disableActiveBlock();
        });
    };
    const enableBlock = (block, toggle)=>{
        if (activeBlock && activeBlock !== block && !isBlockFullscreen(activeBlock)) setBlockEnabled(activeBlock, false);
        const scrollPosition = captureScrollPosition(block);
        const iframeSync = syncIframeFromToggle(block, toggle);
        activeBlock = block;
        setBlockEnabled(block, true);
        if (toggle && document.activeElement === toggle) toggle.blur();
        preserveScrollAroundIframeLoad(block, iframeSync.iframe, scrollPosition, iframeSync.srcChanged);
    };
    const initBlock = (block)=>{
        if (block.dataset.bmtgTour360Ready === 'true') return;
        block.dataset.bmtgTour360Ready = 'true';
        setBlockEnabled(block, false);
        syncCookieBlockerState(block);
        const toggles = getToggles(block);
        const closeButton = getCloseButton(block);
        if (!toggles.length) return;
        setActiveToggle(block, block.querySelector('[data-bmtg-tour-360-toggle].is-active-tour') || toggles[0]);
        toggles.forEach((toggle)=>{
            toggle.addEventListener('click', (event)=>{
                event.preventDefault();
                enableBlock(block, toggle);
            });
        });
        if (closeButton) closeButton.addEventListener('click', (event)=>{
            event.preventDefault();
            disableBlock(block, true);
        });
        if ('MutationObserver' in window) {
            const observer = new MutationObserver(()=>syncCookieBlockerState(block));
            observer.observe(block, {
                childList: true
            });
        }
    };
    const initBlocks = ()=>{
        document.querySelectorAll(blockSelector).forEach(initBlock);
    };
    document.addEventListener('pointerdown', (event)=>{
        if (!activeBlock || activeBlock.contains(event.target)) return;
        disableActiveBlock();
    });
    document.addEventListener('focusin', (event)=>{
        if (!activeBlock || activeBlock.contains(event.target)) return;
        disableActiveBlock();
    });
    document.addEventListener('keydown', (event)=>{
        if (activeBlock && isBlockFullscreen(activeBlock)) return;
        if (event.key === 'Escape') disableActiveBlock();
    });
    window.addEventListener('scroll', scheduleViewportCheck, {
        passive: true
    });
    window.addEventListener('resize', scheduleViewportCheck);
    const syncFullscreenState = ()=>{
        const fullscreenBlock = getFullscreenBlock();
        document.querySelectorAll(blockSelector).forEach((block)=>{
            block.classList.toggle(fullscreenClassName, block === fullscreenBlock);
        });
        if (!fullscreenBlock) return;
        activeBlock = fullscreenBlock;
        setBlockEnabled(fullscreenBlock, true);
    };
    [
        'fullscreenchange',
        'webkitfullscreenchange',
        'mozfullscreenchange',
        'MSFullscreenChange'
    ].forEach((eventName)=>{
        document.addEventListener(eventName, syncFullscreenState);
    });
    if ('IntersectionObserver' in window) {
        const observer = new IntersectionObserver((entries)=>{
            entries.forEach((entry)=>{
                if (entry.target === activeBlock && !isBlockFullscreen(activeBlock) && (!entry.isIntersecting || entry.intersectionRatio < 0.35)) disableActiveBlock();
            });
        }, {
            threshold: [
                0,
                0.35,
                0.65,
                1
            ]
        });
        const observeBlocks = ()=>{
            document.querySelectorAll(blockSelector).forEach((block)=>observer.observe(block));
        };
        if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', observeBlocks, {
            once: true
        });
        else observeBlocks();
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initBlocks, {
        once: true
    });
    else initBlocks();
})();

})();
//# sourceMappingURL=tour-360.js.map
